// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { FieldRule, FieldRuleT, verifyFieldRule } from "./field-rule";

export class RecordRule implements flatbuffers.IUnpackableObject<RecordRuleT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): RecordRule {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsRecordRule(bb: flatbuffers.ByteBuffer, obj?: RecordRule): RecordRule {
    return (obj || new RecordRule()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsRecordRule(bb: flatbuffers.ByteBuffer, obj?: RecordRule): RecordRule {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new RecordRule()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  fields(index: number, obj?: FieldRule): FieldRule | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new FieldRule()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  fieldsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startRecordRule(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addFields(builder: flatbuffers.Builder, fieldsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, fieldsOffset, 0);
  }

  static createFieldsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startFieldsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endRecordRule(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // fields
    return offset;
  }

  static createRecordRule(
    builder: flatbuffers.Builder,
    fieldsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    RecordRule.startRecordRule(builder);
    RecordRule.addFields(builder, fieldsOffset);
    return RecordRule.endRecordRule(builder);
  }

  unpack(): RecordRuleT {
    return new RecordRuleT(
      this.bb!.createObjList<FieldRule, FieldRuleT>(this.fields.bind(this), this.fieldsLength()),
    );
  }

  unpackTo(_o: RecordRuleT): void {
    _o.fields = this.bb!.createObjList<FieldRule, FieldRuleT>(
      this.fields.bind(this),
      this.fieldsLength(),
    );
  }

  unpackFields(...fields: string[]): RecordRuleT {
    const t = new RecordRuleT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("fields")) {
      t.fields = this.bb!.createObjList<FieldRule, FieldRuleT>(
        this.fields.bind(this),
        this.fieldsLength(),
      );
    }
    return t;
  }
}

export class RecordRuleT implements flatbuffers.IGeneratedObject {
  constructor(public fields: FieldRuleT[] = []) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.fields === null || this.fields === undefined) {
      throw new Error('Required field "fields" is not set');
    }
    const fields = RecordRule.createFieldsVector(
      builder,
      builder.createObjectOffsetList(this.fields),
    );

    return RecordRule.createRecordRule(builder, fields);
  }

  clone(): RecordRuleT {
    const obj = new RecordRuleT();
    obj.fields = this.fields.map((e) => e.clone());
    return obj;
  }

  equals(other: RecordRuleT): boolean {
    if (this.fields.length !== other.fields.length) return false;
    for (let i = 0; i < this.fields.length; i++) {
      const a = this.fields[i];
      const b = other.fields[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyRecordRule(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyFieldRule);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "fields");
  } finally {
    verifier.popDepth();
  }
}
